module.exports = __webpack_public_path__ + "static/Quoting-808cd639cc415a4db206311944f5c9d8.jpg";